import { c as _c } from "react/compiler-runtime";
import { useSenderEmailValidList } from 'shared/components/sender-email-select/hooks/use-sender-email-valid-list';
import useUser from 'shared/hooks/use-user';
import { useSubstituteEmails } from './use-substitute-emails';
export const useNormalizeSenderEmail = () => {
  const $ = _c(8);
  const {
    user
  } = useUser();
  const {
    data: senderEmailValidList
  } = useSenderEmailValidList();
  const {
    substituteEmails
  } = useSubstituteEmails();
  const userAccountEmail = user?.mainUser?.user.email;
  const isReadyToNormalize = !!userAccountEmail && !!senderEmailValidList && !!substituteEmails;
  let t0;
  if ($[0] !== isReadyToNormalize || $[1] !== senderEmailValidList || $[2] !== substituteEmails || $[3] !== userAccountEmail) {
    t0 = email => {
      if (!isReadyToNormalize) {
        return email;
      }
      const isUserAccountEmail = userAccountEmail === email;
      const isEmailValid = senderEmailValidList.some(item => item.email === email);
      const substituteEmail = substituteEmails[email];
      if (isUserAccountEmail && !isEmailValid && substituteEmail) {
        return "";
      }
      return email;
    };
    $[0] = isReadyToNormalize;
    $[1] = senderEmailValidList;
    $[2] = substituteEmails;
    $[3] = userAccountEmail;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const normalizeSenderEmail = t0;
  let t1;
  if ($[5] !== isReadyToNormalize || $[6] !== normalizeSenderEmail) {
    t1 = {
      isReadyToNormalize,
      normalizeSenderEmail
    };
    $[5] = isReadyToNormalize;
    $[6] = normalizeSenderEmail;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
};